module.exports = __webpack_public_path__ + "195c6a36ef6cdd42f3583412904cb70a.svg";